

$(document).ready(function(){
  var mf = JSON.parse($('[data-section-type="static-product"]').text());
  var moneyF = mf.settings.money_format;
  
  function adjustMaxQty(m2_per_unit,qty) {
    var maxQty = null;
    var price = 0;
    if (jQuery('.product-block-list__item select[name="id"]').length > 0) {
      var option = jQuery('.product-block-list__item select[name="id"] option:selected');
      if (option.data('inventory-policy') == 'deny') maxQty = option.data('qty');
      price = parseInt(option.data('price'));
    } else if (jQuery('.product-block-list__item input[name="id"]').length > 0) {
      if (jQuery('.product-block-list__item input[name="id"]').data('inventory-policy') == 'deny') maxQty = jQuery('.product-block-list__item input[name="id"]').data('qty');
      price = parseInt(jQuery('.product-block-list__item input[name="id"]').data('price'));
    }
//     var qty = parseInt(jQuery('[name="quantity"]').val());
    var percent = (document.querySelector('#wastage') ? parseFloat(document.querySelector('#wastage').value) : 0);

    if (percent > 0 && document.querySelector('#wastage').checked) {
      if (maxQty != null && qty > maxQty) {
        qty = maxQty;
        var realQty = Math.floor(maxQty / (100.0+percent) * 100.0);
        document.querySelector('#unit-qty').value = realQty;
        if (m2_per_unit != null) {
          var m2Qty = document.querySelector('#unit-qty').value * m2_per_unit;
          document.querySelector('#m2-qty').value = m2Qty.toFixed(2);
        }
//         if(api_loaded) {
//           $('#modal-insufficient-qty .modal__inner').html('Insufficient stock for this quantity');
//           jQuery('[aria-controls="modal-insufficient-qty"]').trigger('click');
//           window.cartInstance._closeMiniCart();
//         }
      }
      jQuery('[name="quantity"]').val(qty);
    } else {
      qty = parseInt(document.querySelector('#unit-qty').value);
      if (maxQty != null && qty > maxQty) {
        document.querySelector('#unit-qty').value = maxQty;
        jQuery('[name="quantity"]').val(maxQty);
        if (m2_per_unit != null) {
          var m2Qty = document.querySelector('#unit-qty').value * m2_per_unit;
          document.querySelector('#m2-qty').value = m2Qty.toFixed(2);
        }
//         if(api_loaded) {
//           $('#modal-insufficient-qty .modal__inner').html('Insufficient stock for this quantity');
//           jQuery('[aria-controls="modal-insufficient-qty"]').trigger('click');
//           window.cartInstance._closeMiniCart();
//         }
      } else
        jQuery('[name="quantity"]').val(qty);
    }
    jQuery('#wastage_total span').text(Shopify.formatMoney((qty * price / 100.0).toFixed(2), moneyF));
//     console.log(qty,m2_per_unit,':ff')
    jQuery('#sqm_total span').text((qty * m2_per_unit).toFixed(2));
  }
  var m2Event = function(event) {
    var m2_per_unit = Number($(this).attr('data-initval'));
    var qty = (event.type == 'keyup' ? Math.ceil(Math.round(this.value / m2_per_unit * 100) / 100) : document.querySelector('#unit-qty').value);
    var origin_qty = qty;
    if (document.querySelector('.wastage-container') && document.querySelector('#wastage').checked) {
      var percent = parseFloat(document.querySelector('#wastage').value);
      qty = Math.ceil(this.value * (100+percent) / 100 / m2_per_unit);
      if (qty == origin_qty) qty = Math.ceil(qty * (100+percent) / 100.0);
    }
//       console.log(qty);

    document.querySelector('#unit-qty').value = origin_qty;
    jQuery('.product-form__info-content [name="quantity"]').val(qty);
    var price = 0;
    if (jQuery('.product-block-list__item select[name="id"]').length > 0) {
      var option = jQuery('.product-block-list__item select[name="id"] option:selected');
      price = parseInt(option.data('price'));
    } else if (jQuery('.product-block-list__item input[name="id"]').length > 0) {
      price = parseInt(jQuery('.product-block-list__item input[name="id"]').data('price'));
    }
    jQuery('#wastage_total span').text(Shopify.formatMoney((qty * price / 100.0).toFixed(2), moneyF));
//     console.log(qty,m2_per_unit,'::ww')
    jQuery('#sqm_total span').text((qty * m2_per_unit).toFixed(2));
    adjustMaxQty(m2_per_unit,qty);
    if (event.type == 'change') {
      let m2Qty = parseFloat(document.querySelector('#unit-qty').value) * m2_per_unit;
      this.value = m2Qty.toFixed(2);
    }
  }
  
  var unitEvent = function(event) {
    var m2_per_unit = $(this).attr('data-initval');
    if (event.type == 'keyup' && this.value < 1) {
      document.querySelector('#m2-qty').value = 0
    } else {
      if (this.value < 1) {
        this.value = 1
      }
      this.value = Math.round(this.value);
      if (m2_per_unit != null) {
        var m2Qty = this.value * m2_per_unit;
        document.querySelector('#m2-qty').value = m2Qty.toFixed(2);
      }

      var qty = this.value;
      var origin_qty = qty;
      if (document.querySelector('.wastage-container') && document.querySelector('#wastage').checked) {
        var percent = parseFloat(document.querySelector('#wastage').value);
        qty = Math.ceil(qty * (100+percent) / 100);
      }

      jQuery('[name="quantity"]').val(qty);
      var price = 0;
      if (jQuery('.product-block-list__item select[name="id"]').length > 0) {
        var option = jQuery('.product-block-list__item select[name="id"] option:selected');
        price = parseInt(option.data('price'));
      } else if (jQuery('.product-block-list__item input[name="id"]').length > 0) {
        price = parseInt(jQuery('.product-block-list__item input[name="id"]').data('price'));
      }
//       console.log(qty,m2_per_unit,price)
      jQuery('#wastage_total span').text(Shopify.formatMoney((qty * price / 100.0).toFixed(2), moneyF));
      jQuery('#sqm_total span').text((qty * m2_per_unit).toFixed(2));
      adjustMaxQty(m2_per_unit);
    }
  }
  var el = document.querySelector('#m2-qty');
if(el){
  el.addEventListener('change', m2Event, false);
  el.addEventListener('keyup', m2Event, false);
}

  
  // document.querySelector('#m2-qty').addEventListener('change', m2Event, false);
  // document.querySelector('#m2-qty').addEventListener('keyup', m2Event, false);

  var elu =  document.querySelector('#unit-qty')
if(elu){
  elu.addEventListener('change', unitEvent, false);
  elu.addEventListener('keyup', unitEvent, false);
}
  
  // document.querySelector('#unit-qty').addEventListener('change', unitEvent, false);
  // document.querySelector('#unit-qty').addEventListener('keyup', unitEvent, false);
  
  if (document.querySelector('.wastage-container')) {
    document.querySelector('#wastage').addEventListener('click', function() {
      // jQuery('#wastage_total').toggleClass('hide', !this.checked);
      if (this.checked) {
//         document.querySelector('.wastage-description span').innerHTML = document.querySelector('.wastage-description').dataset.ticked;
        document.getElementById('sqm_total').classList.remove('hide')
      } else {
//         document.querySelector('.wastage-description span').innerHTML = document.querySelector('.wastage-description').dataset.unticked;
        document.getElementById('sqm_total').classList.add('hide')
      }
//       console.log('in here')
      const event = new Event('change');
      document.querySelector('#m2-qty').dispatchEvent(event);
    });
  }
  
  var areaOpener = document.querySelector(".area-calculator__head--inner");
  if (areaOpener) {
    areaOpener.addEventListener("click", function () {
      this.closest(".area-calculator").classList.toggle("opened");
    });
    const e = document.getElementById("add-area");
    const t = document.getElementById("area-field-template").innerHTML;
    const r = document.querySelector(".area-calculator__main--inner");
    function refreshValue() {
      let e = 0;
      const t = document.querySelectorAll(".area-item");
      for (var r = 0; r < t.length; r++) {
        let n = t[r];
        const i = n.querySelectorAll("input");
        let a = 1;
        for (var o = 0; o < i.length; o++) {
          const e = undefined;
          "ft" == i[o].closest(".area-item__column").querySelector("select").value ? (a = a * (parseFloat(i[o].value) || 0) * 0.3048) : (a *= parseFloat(i[o].value) || 0);
        }
//         console.log(a,'refreshval');
        (e += a), (n.querySelector(".area-unit__result-detail").innerHTML = a.toFixed(2));
      }
      if (((document.querySelector(".calculation-result__details").innerHTML = e.toFixed(2)), e > 0 && document.querySelector("#m2-qty"))) {
        document.querySelector("#m2-qty").value = e.toFixed(2);
        const t = new Event("keyup");
        document.querySelector("#m2-qty").dispatchEvent(t);
        const r = new Event("change");
        document.querySelector("#m2-qty").dispatchEvent(r);
      }
    }
    function resetPositionTexts() {
      const e = document.querySelectorAll(".area-calculator__main--inner .area-item");
      if (e)
        for (var t = 0; t < e.length; t++) {
          let r = t + 1;
          e[t].querySelector(".area-label").innerHTML = "Area " + r;
        }
    }
    function initArea(e) {
      const t = e.querySelector(".area-unit__remove");
      t &&
        t.addEventListener("click", function () {
        this.closest(".area-item").remove(), refreshValue(), resetPositionTexts();
      });
      const r = e.querySelectorAll("input");
      for (var o = 0; o < r.length; o++)
        r[o].addEventListener("keyup", function () {
          !isNaN(this.value) && parseFloat(this.value) < 0 && (this.value = 0), refreshValue();
        });
      const n = e.querySelectorAll("select");
      for (var o = 0; o < n.length; o++)
        n[o].addEventListener("change", function () {
          const e = this.value;
          let t = this.closest(".area-item__column").querySelector("input");
          let r = $(this).closest(".area-item").find("select").not(this)[0];
//           console.log('in n here');
          if ("ft" == e) {
            if ((isNaN(t.value) || (t.value = (parseFloat(t.value) / 0.3048).toFixed(2)), "m" == r.value)) {
              let e = r.closest(".area-item__column").querySelector("input");
              (r.value = "ft"), isNaN(e.value) || (e.value = (parseFloat(e.value) / 0.3048).toFixed(2));
            }
          } else if ((isNaN(t.value) || (t.value = (0.3048 * parseFloat(t.value)).toFixed(2)), "ft" == r.value)) {
            let e = r.closest(".area-item__column").querySelector("input");
            (r.value = "m"), isNaN(e.value) || (e.value = (0.3048 * parseFloat(e.value)).toFixed(2));
          }
          refreshValue();
        });
    }
    e.addEventListener("click", function () {
      $(r).append(t), resetPositionTexts(), initArea(r.querySelector(".area-item:last-child"));
    });
    resetPositionTexts(); initArea(r.querySelector(".area-item:last-child"));
    var event = new Event("click");
    e.dispatchEvent(event);
  }
});